import React, { useState } from 'react'
import uniqid from 'uniqid'

export type ExpandableCellProps = {
  defaultLength: number
  items: string[]
}

const handleClick = (
  setState: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setState((prevExpanded) => !prevExpanded)
}
export const ExpandableCell = ({
  defaultLength,
  items
}: ExpandableCellProps) => {
  const [isExpanded, setState] = useState(false)
  const viewClass = isExpanded ? '' : 'forDemo'

  return (
    <ul>
      {items.length &&
        items.map((elem, i) =>
          i < defaultLength ? (
            <li key={uniqid()} data-testid="listData">
              {elem}
            </li>
          ) : (
            <li
              className={viewClass}
              data-testid={viewClass === 'forDemo' ? '' : 'listData'}
              key={uniqid()}
            >
              {elem}
            </li>
          )
        )}
      {items.length > defaultLength ? (
        <div
          className="link--1"
          onKeyUp={() => handleClick(setState)}
          onClick={() => handleClick(setState)}
          role="presentation"
        >
          {isExpanded ? 'VIEW LESS' : 'VIEW MORE'}
        </div>
      ) : null}
    </ul>
  )
}
